"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoCurtainClickHandler = void 0;
const react_1 = require("react");
const types_1 = require("src/components/types");
// eslint-disable-next-line import/prefer-default-export
function useVideoCurtainClickHandler({ status, service, handleStatus, playerRef }) {
    const playAttempts = (0, react_1.useRef)(0);
    const handleClick = (0, react_1.useCallback)(e => {
        if (status === types_1.AttachmentStatus.Initial) {
            handleStatus(types_1.AttachmentStatus.Playing);
            playAttempts.current = 0;
            const attemptPlay = () => {
                var _a, _b, _c;
                playAttempts.current += 1;
                if (playAttempts.current === 1) {
                    (_a = playerRef.current) === null || _a === void 0 ? void 0 : _a.playVideo();
                    setTimeout(attemptPlay, 500);
                }
                else if (playAttempts.current === 2) {
                    (_b = playerRef.current) === null || _b === void 0 ? void 0 : _b.mute();
                    (_c = playerRef.current) === null || _c === void 0 ? void 0 : _c.playVideo();
                    setTimeout(() => {
                        var _a;
                        (_a = playerRef.current) === null || _a === void 0 ? void 0 : _a.unMute();
                    }, 1000);
                }
            };
            setTimeout(attemptPlay, 200);
        }
    }, [status, handleStatus, playerRef]);
    return service === 'rutube' ? handleClick : undefined;
}
exports.useVideoCurtainClickHandler = useVideoCurtainClickHandler;
